import { sendRequest } from "@/utils/ApiUtil";

export interface LocationDataProps {
  value: string;
  code: string;
  uniqueKey: string;
}

export interface LocationData {
  countries: LocationDataProps[];
  states: LocationDataProps[];
  cities: LocationDataProps[];
}

interface LocationParams {
  searchTerm: string;
  countryCode?: string;
  stateCode?: string;
}

interface LocationMapping {
  country?: string;
  state?: string;
  city?: string;
  stateCode?: string;
  countryCode?: string;
  code?: string;
}

export async function fetchLocation(
  searchTerm: string,
  type: string,
  stateCode: string,
  countryCode?: string,
) {
  const requestData: LocationParams = {
    searchTerm,
  };

  if (type === "states") requestData.countryCode = countryCode;
  if (type === "cities") {
    requestData.countryCode = countryCode;
    requestData.stateCode = stateCode;
  }
  try {
    const response = await sendRequest("get", `/${type}`, requestData);
    const mappedResponse = response.map((item: LocationMapping) => ({
      value: item.country || item.state || item.city,
      code: item.code || item.stateCode,
      uniqueKey: `state-${item.country || item.state}-${
        item.code || item.stateCode
      }`,
    }));
    return mappedResponse;
  } catch (error) {
    console.error(`Error fetching ${type}:`, error);
  }
}
